import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import EnterpriseShell from "./EnterpriseShell";
import RequireOrgMember from "@/enterprise/components/RequireOrgMember";
import { EnterpriseThemeProvider } from "@/enterprise/theme/ThemeProvider";

// Pages
import Home from "./pages/Home";
import Devices from "./pages/Devices";
import Analytics from "./pages/Analytics";
import Members from "./pages/Members";
import Settings from "./pages/Settings";
import Privacy from "./pages/Privacy";

export default function EnterpriseRoutes() {
  return (
    <EnterpriseThemeProvider>
      <Routes>
        <Route
          element={
            <RequireOrgMember>
              <EnterpriseShell />
            </RequireOrgMember>
          }
        >
          <Route index element={<Home />} />
          <Route path="devices" element={<Devices />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="members" element={<Members />} />
          <Route path="settings" element={<Settings />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/enterprise" replace />} />
        </Route>
      </Routes>
    </EnterpriseThemeProvider>
  );
}
